// extracted by mini-css-extract-plugin
export default {"container":"ReadMore_container__-5Ios"};